/**
 * BETA — stock lots + alerts + corrections.
 */
import { httpError } from "../router.js";
import { paginate, matchSearch, newId, nowIso } from "./_utils.js";
import { alertsResult } from "./produits.js";

const correctionsByLot = new Map();

export function register(route) {
  route("GET", "/stock/lots", (ctx) => {
    const { params, store } = ctx;
    let rows = (store.data.stockLots || []).map((l) => {
      const p = store.data.produits.find((x) => x.id === l.produit_id);
      return { ...l, produit: p ? { id: p.id, nom_commercial: p.nom_commercial, dci: p.dci, ppa: p.ppa, code_barre: p.code_barre } : null };
    });
    if (params.produit_id) rows = rows.filter((l) => l.produit_id === params.produit_id);
    if (params.statut) rows = rows.filter((l) => l.statut === params.statut);
    if (params.date_peremption_before) rows = rows.filter((l) => l.date_peremption <= params.date_peremption_before);
    if (params.date_peremption_after) rows = rows.filter((l) => l.date_peremption >= params.date_peremption_after);
    if (params.search)
      rows = rows.filter((l) =>
        matchSearch(l, params.search, ["numero_lot"]) ||
        matchSearch(l.produit || {}, params.search, ["nom_commercial", "dci"]),
      );
    if (params.low_stock_only === "true" || params.low_stock_only === true) {
      rows = rows.filter((l) => (l.quantite_actuelle || 0) < 20);
    }
    const sortBy = params.sort_by || "date_peremption";
    rows.sort((a, b) => (a[sortBy] > b[sortBy] ? 1 : -1));
    return paginate(rows, params);
  });

  route("GET", "/stock/lots/:id", (ctx) => {
    const l = ctx.store.data.stockLots.find((x) => x.id === ctx.params.id);
    if (!l) httpError(404, "Lot introuvable", "NOT_FOUND");
    const p = ctx.store.data.produits.find((x) => x.id === l.produit_id);
    return { ...l, produit: p, corrections: correctionsByLot.get(l.id) || [] };
  });

  route("GET", "/stock/alerts", (ctx) => alertsResult(ctx.store));

  route("POST", "/stock/corrections", (ctx) => {
    const body = ctx.body || {};
    const lot = ctx.store.data.stockLots.find((x) => x.id === body.stock_lot_id);
    if (!lot) httpError(404, "Lot introuvable", "NOT_FOUND_LOT");
    const before = lot.quantite_actuelle;
    const after = Number(body.quantite_corrigee);
    lot.quantite_actuelle = after;
    const correction = {
      id: newId("corr"),
      stock_lot_id: lot.id,
      before,
      after,
      delta: after - before,
      motif: body.motif || "",
      created_at: nowIso(),
      user_id: ctx.store.data.users[0]?.id || null,
    };
    const list = correctionsByLot.get(lot.id) || [];
    list.unshift(correction);
    correctionsByLot.set(lot.id, list);
    // Sync produit.stock_actuel
    const p = ctx.store.data.produits.find((x) => x.id === lot.produit_id);
    if (p) p.stock_actuel = Math.max(0, (p.stock_actuel || 0) + (after - before));
    ctx.commit();
    return correction;
  });

  route("GET", "/stock/lots/:id/corrections", (ctx) =>
    correctionsByLot.get(ctx.params.id) || [],
  );
}
